module.exports = __webpack_public_path__ + "static/media/bolkarAbout.7a28698f.webp";